document.addEventListener("DOMContentLoaded", function () {
	let checkboxes = [];
	let checkoutButton = document.querySelector("#checkout");
	let cartDrawerCheckoutButton = null;
	const paypalButtonContainer = document.querySelector(".cart__dynamic-checkout-buttons");

	const modal = document.getElementById("wszCustomModal");
	const modalMessage = document.getElementById("wszModalMessage");
	const closeModal = document.getElementById("wszCloseModal");

	const errorMessage =
		window.translations?.checkboxError ||
		"Kérlek, fogadd el az összes szükséges feltételt a folytatáshoz.";

	modalMessage.textContent = errorMessage;

	let firstClickAttempt = false;
	let initialized = false;

	function getCheckboxes() {
		checkboxes = document.querySelectorAll(".custom-checkbox");
	}

	function validateCheckboxes() {
		let allChecked = true;

		checkboxes.forEach((checkbox) => {
			const errorElements = document.querySelectorAll(
				`#${checkbox.id}-error, .error-message[data-error-for="${checkbox.name}"]`
			);

			if (!checkbox.checked) {
				allChecked = false;
				if (firstClickAttempt) {
					errorElements.forEach((errorElement) => {
						errorElement.textContent = errorMessage;
						errorElement.style.display = "block";
					});
				}
			} else {
				errorElements.forEach((errorElement) => {
					errorElement.style.display = "none";
				});
			}
    //  console.log('itt> ' + allChecked);
		});

		[checkoutButton, cartDrawerCheckoutButton].forEach((button) => {
			if (button) {
				button.disabled = !allChecked;
				button.classList.toggle("disabled", !allChecked);
			}
		});

		if (paypalButtonContainer) {
			paypalButtonContainer.style.pointerEvents = allChecked ? "auto" : "none";
			paypalButtonContainer.style.opacity = allChecked ? "1" : "0.5";
		}
	}

	function bindCheckboxes() {
		getCheckboxes();
		checkboxes.forEach((checkbox) => {
			if (!checkbox.dataset.listenerAdded) {
				checkbox.addEventListener("change", function () {
                    document
						.querySelectorAll(`.custom-checkbox[name="${checkbox.name}"]`)
						.forEach((chk) => {
							chk.checked = checkbox.checked;
						});

					document
						.querySelectorAll(
							`#${checkbox.id}-error, .error-message[data-error-for="${checkbox.name}"]`
						)
						.forEach((errorElement) => {
							errorElement.style.display = "none";
						});

					//if (firstClickAttempt) {
						validateCheckboxes();
					//}
				});
				checkbox.dataset.listenerAdded = "true";
			}
		});
		validateCheckboxes();
	}

	function bindCheckoutButtons() {
		[checkoutButton, cartDrawerCheckoutButton].forEach((button) => {
			if (button && !button.dataset.listenerAdded) {
				button.addEventListener("click", function (e) {
					firstClickAttempt = true;
					let allChecked = true;

					checkboxes.forEach((checkbox) => {
						if (!checkbox.checked) {
							allChecked = false;
						}
					});

					validateCheckboxes();

					if (!allChecked) {
						e.preventDefault();
						modal.style.display = "flex";
					}
				});
				button.dataset.listenerAdded = "true";
			}
		});
	}

	function initializeElements() {
		getCheckboxes();
		cartDrawerCheckoutButton = document.querySelector("#CartDrawer-Checkout");

		if (checkboxes.length > 0 || cartDrawerCheckoutButton) {
			bindCheckboxes();
			bindCheckoutButtons();
			initialized = true;
		}
	}

	function resetInitialization() {
		initialized = false;
		checkboxes = [];
	}

	const observer = new MutationObserver(() => {
		const cartDrawer = document.querySelector("cart-drawer");

		if (!cartDrawer) return;

		const isEmpty = cartDrawer.querySelector(".is-empty");
		const hasItems = cartDrawer.querySelector(".cart-item");
       // console.log('change');
        
		if (!hasItems) { //&& initialized
           // console.log('no item');
		}
        if (hasItems && !initialized) {
          //  console.log('yes item');
		}
      
			resetInitialization();
			initializeElements();
			
      /*
		 else if (hasItems && !initialized) {
            console.log('yes item');
			initializeElements();
		}*/
	});

	const cartDrawer = document.querySelector("cart-drawer");
	if (cartDrawer) {
		observer.observe(cartDrawer, {
			childList: true,
			subtree: true,
		});
	}

	// Kezdeti futtatás (ha oldalbetöltéskor is vannak elemek)
	initializeElements();
	bindCheckoutButtons();

	closeModal.addEventListener("click", function () {
		modal.style.display = "none";
	});

	modal.addEventListener("click", function (e) {
		if (e.target === modal) {
			modal.style.display = "none";
		}
	});
});
